<div class="row h-100">
    <div class="col-12 p-0 h-100">
        <p>Unauthorized</p>
        <a [routerLink]="['..','login']">Go to Login</a>
    </div>
</div>